<style lang="scss" scoped>
  .fadeSlider {
  }

  .fadeSlider__item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;

    img {
      opacity: 0;
      transition: opacity 1s 0s ease;
    }

    &.is-active-slide {
      z-index: 1;

      img {
        opacity: 1;
      }
    }
  }

  // .fade-slider-enter-active,
  // .fade-slider-leave-active {
  //   transition: opacity 3s 0s ease;
  // }
  // .fade-slider-enter-to {
  //   opacity: 1;
  // }
  // .fade-slider-leave-to {
  //   opacity: 0;
  // }
</style>

<template>
  <div class="fadeSlider">
    <div v-for="(item, i) in items" :key="item.id" class="fadeSlider__item" :class="[options.itemClass, { 'is-active-slide': now === i }]">
      <!--transition name="fade-slider"-->
      <!--img :src="item.image" alt="" :key="now"-->
      <img :src="item.image.url" alt="item.image.alt">
      <!--/transition-->
    </div>
  </div>
</template>

<script>
  // import _ from "./utils";

  export default {
    props: {
      slideData: {
        type: Array,
        default() {
          return [];
        }
      },
      custom: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        template: {
          id: 0,
          image: ''
        },
        options: {
          duration: 7000,
          itemClass: '',
          autoplay: true
        },
        items: [],
        now: 0,
        maxLength: 0
      }
    },
    watch: {
      now: 'changeSlide'
    },
    created() {
      this.init();

      this.$on('onSelect', this.selectSlide);
    },
    beforeDestroy() {
    },
    methods: {
      init() {
        // データ判定
        if(!this.slideData.length) {
          this.items.push(this.template);
        }

        // 最大スライド数
        this.maxLength = this.slideData.length - 1;

        // モデルを更新
        this.slideData.forEach(item => {
          // var slide = Object.assign(this.template, item);
          this.items.push(item);
        })

        // オプションを更新
        this.options = Object.assign(this.options, this.custom);

        // コールバック
          // 現在アクティブなスライドを返却
          this.$emit('onChange', this.now);

        // オプションで有効化されている関数を実行
        Object.keys(this.options).forEach(key => {
          if(this.options[key] && typeof this.o()[key] === 'function') this.o()[key]();
        })
      },
      o() {
        return {
          'autoplay': () => {
            setInterval(() => {
              this.now = this.now < this.maxLength ? this.now + 1 : 0;
            }, this.options.duration);
          }
        }
      },
      changeNav(num) {
        this.now = num;
      },
      changeSlide() {
        this.$emit('onChange', this.now);
      },
      selectSlide(n) {
        this.now = n;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/plugins/fadeSlider/component.vue